import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaTextAreaComponent } from './viva-text-area.component';

@NgModule({
  declarations: [
    VivaTextAreaComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaTextAreaComponent
  ]
})
export class  VivaTextAreaModule { }
